import { useContext } from "react";
import { ConfigurationContext } from "contexts";

/**
 * Should the effect run.
 *
 * @param {object} config The configuration.
 */

// const shouldRun = (config) => {
//   try {
//     return config.steps.appDetection;
//   } catch (error) {
//     return false;
//   }
// };

/** Get the app version from the configuration.
 *
 *  @param {object} config The configuration.
 */
const getAppVersion = (config) => {
  if (config.os.includes("win")) {
    return config.windowsAppVersion;
  }
  if (config.os.includes("mac")) {
    return config.macAppVersion;
  }
  console.log("App version not found.");
  return "0.0";
};

/** Get the app OS (windows, mac, chrome) from the configuration.
 *
 *  @param {object} config The configuration.
 */
const getAppOs = (config) => {
  if (config.os.includes("win")) {
    return "windows";
  }
  if (config.os.includes("mac")) {
    return "macos";
  }

  console.log("App OS not found.");
  return "";
};

/** App Detection hook.
 *
 *  @param {function} onProgress Progress handler.
 *  @param {function} onDone Done handler.
 *  @param {function} onError Error handler.
 */
export const useChromeExtensionDetection = (onProgress, onDone) => {
  let config = useContext(ConfigurationContext);

  const run = () => {
    // Set the detection settings.
    window.SRL.detection.init({
      loggingLevel: 2,
      host: "www",
      protocol: "https",
      referrerId: config.referrerId,
      computerId: config.computerId,
      //      detectionAppVersion: getAppVersion(config),
      //      detectionAppOs: getAppOs(config),
      onProgress: onProgress,
      //  onError: onError,
      onDone: onDone,
    });

    // Run the detection.
    window.SRL.detection
      .runChromeExtensionScan()
      .then(() => {})
      .catch((error) => {
        console.log(`Caught ${error.name} error: ${error.message}`);
      });
  };

  return run;
};
